import { render, staticRenderFns } from "./follow-record-search.vue?vue&type=template&id=33e6ea36"
import script from "./follow-record-search.vue?vue&type=script&lang=ts"
export * from "./follow-record-search.vue?vue&type=script&lang=ts"
import style0 from "./follow-record-search.vue?vue&type=style&index=0&id=33e6ea36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports